
import {debounceTime} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {AddPopupComponent} from '../Popups/add-popup/add-popup.component';
import {ChangeOrganizationParentComponent} from '../Popups/change-organization-parent/change-organization-parent.component';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import { Title } from '@angular/platform-browser/src/browser/title';
import { OrganizationService } from '../../shared/services/organization.service';
import { Sort } from '@angular/material';
import { ToastService } from '../../shared/services/toast.service';
import {Location} from '@angular/common';

@Component({
  selector: 'app-heirarchy',
  templateUrl: './heirarchy.component.html',
  styleUrls: ['./heirarchy.component.css']
})
export class HeirarchyComponent implements OnInit {
  public companies: any;
  public selectedParent: any;
  public sortedData = [];
  public graphicalOrTabuler = 'tabular';

  constructor(public dialog: MatDialog,
              public mobileNav: MobileNavService,
              public snackbar: MatSnackBar,
              public _location: Location,
              public organizaitonService: OrganizationService,
              public toastService: ToastService) { }

  openDialog(): void {
    let dialogRef = this.dialog.open(AddPopupComponent, {
      width: '300px',
      data: {title: 'Add new Organization',
      // fun:function(){
      //   console.log("call back from heirachy component");
      // }
      fun: this.hello
    },
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openEditDialog(index: number): void {
    let dialogRef = this.dialog.open(ChangeOrganizationParentComponent, {
      width: '450px',
      data: {
        title: 'Organization Update',
        index: index,
        companies: this.companies
    },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== 'Cancel') {
        if (result) {
          if (result.selected !== 'No Parent') {
            let tempArr = this.companies;
            let posParent = {};
            let posLevel = {};
            let ancestorsObject = {};
            let currentCompanyName = this.companies[index].company.companyName;
            let comparisonName = this.companies[index].company.companyName;
            tempArr.forEach(pos => {
                posParent[pos.company.companyName] = pos.company.parentCompany.name;
                posLevel[pos.company.companyName] = null;
            });
            let updatePermission = true;
            let tempParentCompany = result.selected.company.companyName;
            let counter = 0;
            // while ( tempParentCompany !== '' ) {
            //   if (tempParentCompany === currentCompanyName || counter === 100 ) {
            //     updatePermission = false;
            //     break;
            //   }
            //    tempParentCompany = posParent[tempParentCompany];
            //    counter++;
            // }
            let subsidiaries = [];
            subsidiaries = this.organizaitonService.getSubsidiariesOrganization([this.companies[index]._id],this.companies);
            console.log('Subsidiaries',subsidiaries);
             if (subsidiaries.indexOf(result.selected._id) >= 0) {
              updatePermission = false;
             }
          if (updatePermission) {
            // update Company
                    this.companies[index].company.parentCompany.name = result.selected.company.companyName;
                    this.companies[index].company.parentCompany.companyId = result.selected.company.companyId;
                    this.companies[index].company.parentCompany.id = result.selected._id;
                    this.organizaitonService.updateOrganization(this.companies[index]).subscribe((data) => {
                      this.organizaitonService.getOrganization().pipe(debounceTime(3000)).subscribe(( response) => {
                        this.companies = response;
                      });
                    }, (error) => {
                      console.log('Error while changing heirarchy');
                    });
          } else {
            // show message company can not be updated
            this.toastService.error(`Error while updating Hierarchy, "${result.selected.company.companyName}"  is subsidiary of
            "${this.companies[index].company.companyName}"`);
          }
        } else {
          this.companies[index].company.parentCompany.name = '';
          this.companies[index].company.parentCompany.companyId = '';
          this.companies[index].company.parentCompany.id = '';
          this.organizaitonService.updateOrganization(this.companies[index]).subscribe((data) => {
            this.organizaitonService.getOrganization().pipe(debounceTime(3000)).subscribe(( response) => {
              this.companies = response;
            });
          }, (error) => {
            console.log('Error while changing heirarchy');
          });
        }
  }
    }
    });
  }

  ngOnInit() {
    this.organizaitonService.getOrganization().subscribe((data) => {
      this.companies = data;
      console.log('asasdasd',this.companies);
    }, ( error ) => {
    })
  }

  onClickMe() {
        this.mobileNav.showSideNav();
    }

    hello() {
      console.log('hello');
    }
    // Sorting Functions
    sortData(sort: Sort) {
      const data = this.companies.slice();
      if (!sort.active || sort.direction === '') {
        this.companies = data;
        return;
      }

      this.companies = data.sort((a, b) => {
        let isAsc = sort.direction === 'asc';
        switch (sort.active) {
          case 'name': return this.compare(a.company.companyName.toLowerCase(), b.company.companyName.toLowerCase(), isAsc);
          case 'level': return this.compare(a.company.companyLevel, b.company.companyLevel, isAsc);
          case 'parentCompany': return this.compare(a.company.parentCompany.name.toLowerCase(),
          b.company.parentCompany.name.toLowerCase(), isAsc);
          default: return 0;
        }
      });
    }


  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
  
  backBtnClick(){
    this._location.back();
  }

  toggle() {
    console.log('toggle')
      if (this.graphicalOrTabuler === 'graphical') {
          this.graphicalOrTabuler = 'tabular';
      } else if (this.graphicalOrTabuler === 'tabular') {
        this.graphicalOrTabuler = 'graphical';
      }
   }

}